import { createContext, useContext } from 'react';

export type Locale = 'ko' | 'en' | 'ja';

const translations: Record<Locale, Record<string, string>> = {
  ko: {
    // Brand
    'app.name': '편리한 복붙 창고 ,  My Favorite Copies',

    // Preview
    'preview.click_paste': '이 영역을 클릭해서 클립보드 내용을 확인하세요',
    'preview.empty': '클립보드에 복사된 데이터 없음',
    'preview.unsupported': '지원하지 않는 형식입니다',
    'preview.permission_denied': '클립보드 권한이 필요합니다. 영역을 클릭 후 Ctrl+V를 눌러주세요',
    'preview.save': '저장',
    'preview.plain_text': '텍스트만',
    'preview.overwrite': '덮어쓰기',
    'preview.format_removed': '문법 제거됨',
    'preview.clear': '비우기',
    'preview.raw_source': '원문',
    'preview.rendered': '렌더링',
    'menu.save': '저장',
    'menu.cancel': '취소',

    // Folder
    'folder.search': '폴더 검색...',
    'folder.empty': '위젯을 여기로 드래그 하시면\n폴더 구조로 관리할 수 있는\n항목이 새로 추가 됩니다.',
    'folder.drop_here': '여기로 드래그하세요',
    'folder.new': '새 폴더',
    'folder.rename': '이름 변경',
    'folder.delete': '폴더 삭제',
    'folder.delete_confirm': '이 폴더를 삭제하시겠습니까?\n하위 폴더와 연결된 항목도 함께 해제됩니다.',
    'folder.items': '{count}개 항목',

    // Widget
    'widget.search': '위젯 검색...',
    'widget.empty': '우측 상단 저장 버튼을 눌러서\n데이터를 저장하세요',
    'widget.text': '문장',
    'widget.image': '이미지',
    'widget.table': '표',
    'widget.html': 'HTML',
    'widget.markdown': '마크다운',
    'widget.columns': '열',
    'widget.rows': '행',
    'widget.page': '페이지',
    'widget.add_page': '페이지 추가',
    'widget.page_added': '{name} 추가됨',
    'widget.rename_page': '페이지 이름 변경',
    'widget.save_page_name': '페이지 이름 저장',
    'widget.cancel_page_rename': '페이지 이름 변경 취소',
    'widget.page_renamed': '{name}(으)로 이름 변경됨',
    'widget.delete_page': '페이지 삭제',
    'widget.delete_page_confirm': '{name} 페이지를 삭제하시겠습니까?\n이 페이지의 위젯은 히스토리에 복구용 사본을 남긴 뒤 삭제됩니다.',
    'widget.page_deleted': '{name} 삭제됨 ({count}개 위젯 보관)',
    'widget.page_delete_last_blocked': '마지막 페이지는 삭제할 수 없습니다',
    'widget.page_name_required': '페이지 이름을 입력하세요',
    'widget.pages_reordered': '페이지 순서를 변경했습니다',

    // History
    'history.search': '히스토리 검색...',
    'history.empty': '클립보드 사용 기록이\n여기에 표시됩니다',

    // Storage
    'storage.used': '{used} / {total} 사용 중 ({percent}%)',
    'storage.remaining': '{size} 남음',
    'storage.status_safe': '저장 공간이 충분합니다',
    'storage.status_warning': '저장 공간이 부족해지고 있습니다',
    'storage.status_critical': '저장 공간이 거의 가득 찼습니다. 정리가 필요합니다.',
    'storage.guide': '사용 가능한 저장 용량은 PC의 디스크 여유 공간과 브라우저 환경에 따라 유동적으로 결정됩니다.',
    'storage.export': '내보내기',
    'storage.import': '가져오기',
    'storage.export_confirm': '데이터 내보내기를 시작하시겠습니까?',
    'storage.import_confirm': '데이터를 가져오시겠습니까?\n현재 저장된 모든 데이터가 백업 데이터로 대체됩니다.',
    'storage.processing': '처리 중',
    'storage.complete': '완료',
    'storage.error': '오류',
    'storage.process_collecting': '데이터 수집 중...',
    'storage.process_compressing': '데이터 압축 중...',
    'storage.process_decompressing': '데이터 압축 해제 중...',
    'storage.process_restoring': '데이터 복구 중...',
    'storage.process_finalizing': '마무리 중...',
    'storage.process_done': '완료되었습니다!',
    'storage.refresh_tip': '화면을 새로고침하여 변경 사항을 확인하세요.',

    // Info
    'info.guide': '가이드',
    'info.feedback': '의견/문의',
    'info.privacy': '개인정보처리방침',
    'info.terms': '이용약관',

    // Context menu
    'menu.copy': '복사',
    'menu.duplicate': '복제',
    'menu.edit_label': '라벨 편집',
    'menu.edit_data': '데이터 수정',
    'menu.delete': '삭제',
    'menu.add_tag': '태그 추가',
    'menu.move_to_folder': '폴더로 이동',

    // Confirm
    'confirm.delete': '정말 삭제하시겠습니까?',
    'confirm.delete_desc': '선택된 {count}개 항목이 삭제됩니다. 이 작업은 되돌릴 수 없습니다.',
    'confirm.yes': '확인',
    'confirm.cancel': '취소',

    // Notice
    'notice.title': '공지 사항',
    'notice.close': '확인',
    'notice.dont_show_today': '오늘 하루 보지 않기',

    // Context menu
    'context.copy': '복제',
    'context.move': '이동',
    'context.delete': '삭제',
    'context.to_widget': '위젯 영역으로',
    'context.to_page': '페이지로',
    'context.save_png': 'PNG 저장',
    'context.copy_image': '클립보드 복사',
    'context.copy_base64': 'Base64 복사',
    'context.save_png_success': 'PNG 저장이 완료되었습니다',
    'context.copy_image_success': '클립보드에 복사되었습니다',
    'context.copy_base64_success': 'Base64 복사가 완료되었습니다',


    // DnD
    'dnd.items': '{count}개 항목',

    // Language
    'lang.ko': '한국어',
    'lang.en': 'English',
    'lang.ja': '日本語',

    // Common
    'common.coming_soon': '준비중',
  },

  en: {
    'app.name': 'Clipboard Drawer,  My Favorite Copies',
    'preview.click_paste': 'Click this area to check clipboard content',
    'preview.empty': 'No data copied to clipboard',
    'preview.unsupported': 'Unsupported format',
    'preview.permission_denied': 'Clipboard permission required. Click the area and press Ctrl+V',
    'preview.save': 'Save',
    'preview.plain_text': 'Text Only',
    'preview.overwrite': 'Overwrite',
    'preview.format_removed': 'Formatting removed',
    'preview.clear': 'Clear',
    'preview.raw_source': 'Source',
    'preview.rendered': 'Rendered',
    'menu.save': 'Save',
    'menu.cancel': 'Cancel',
    'folder.search': 'Search folders...',
    'folder.empty': 'Drag widgets here\nto organize them\ninto folders.',
    'folder.drop_here': 'Drop here',
    'folder.new': 'New Folder',
    'folder.rename': 'Rename',
    'folder.delete': 'Delete Folder',
    'folder.delete_confirm': 'Delete this folder?\nSub-folders and linked items will be unlinked.',
    'folder.items': '{count} items',
    'widget.search': 'Search widgets...',
    'widget.empty': 'Press the save button\nto save data',
    'widget.text': 'Text',
    'widget.image': 'Image',
    'widget.table': 'Table',
    'widget.html': 'HTML',
    'widget.markdown': 'Markdown',
    'widget.columns': 'Columns',
    'widget.rows': 'Rows',
    'widget.page': 'Page',
    'widget.add_page': 'Add page',
    'widget.page_added': '{name} added',
    'widget.rename_page': 'Rename page',
    'widget.save_page_name': 'Save page name',
    'widget.cancel_page_rename': 'Cancel page rename',
    'widget.page_renamed': 'Renamed to {name}',
    'widget.delete_page': 'Delete page',
    'widget.delete_page_confirm': 'Delete {name}?\nWidgets on this page will be copied to history before removal.',
    'widget.page_deleted': '{name} deleted ({count} widgets archived)',
    'widget.page_delete_last_blocked': 'The last page cannot be deleted',
    'widget.page_name_required': 'Enter a page name',
    'widget.pages_reordered': 'Page order updated',
    'history.search': 'Search history...',
    'history.empty': 'Clipboard history\nwill appear here',
    'storage.used': '{used} / {total} used ({percent}%)',
    'storage.remaining': '{size} remaining',
    'storage.status_safe': 'Storage usage is healthy',
    'storage.status_warning': 'Storage is getting full',
    'storage.status_critical': 'Storage is almost full. Consider clearing history.',
    'storage.guide': 'Available storage quota is dynamically determined by your device\'s disk space and browser environment.',
    'storage.export': 'Export',
    'storage.import': 'Import',
    'storage.export_confirm': 'Start data export?',
    'storage.import_confirm': 'Import data?\nAll current data will be replaced by the backup.',
    'storage.processing': 'Processing',
    'storage.complete': 'Complete',
    'storage.error': 'Error',
    'storage.process_collecting': 'Collecting data...',
    'storage.process_compressing': 'Compressing data...',
    'storage.process_decompressing': 'Decompressing...',
    'storage.process_restoring': 'Restoring data...',
    'storage.process_finalizing': 'Finalizing...',
    'storage.process_done': 'Done!',
    'storage.refresh_tip': 'Refresh the page to see changes.',
    'info.guide': 'Guide',
    'info.feedback': 'Feedback',
    'info.privacy': 'Privacy Policy',
    'info.terms': 'Terms of Service',
    'menu.copy': 'Copy',
    'menu.duplicate': 'Duplicate',
    'menu.edit_label': 'Edit label',
    'menu.edit_data': 'Edit data',
    'menu.delete': 'Delete',
    'menu.add_tag': 'Add tag',
    'menu.move_to_folder': 'Move to folder',
    'confirm.delete': 'Are you sure you want to delete?',
    'confirm.yes': 'OK',
    'confirm.cancel': 'Cancel',

    // Notice
    'notice.title': 'Notice',
    'notice.close': 'Confirm',
    'notice.dont_show_today': 'Do not show for today',

    // Context menu
    'context.copy': 'Copy',
    'context.move': 'Move',
    'context.delete': 'Delete',
    'context.to_widget': 'To Widget Area',
    'context.to_page': 'To page',
    'context.save_png': 'Save as PNG',
    'context.copy_image': 'Copy to Clipboard',
    'context.copy_base64': 'Copy Base64',
    'context.save_png_success': 'PNG saved successfully',
    'context.copy_image_success': 'Copied to clipboard',
    'context.copy_base64_success': 'Base64 copied successfully',

    'lang.ko': '한국어',
    'lang.en': 'English',
    'lang.ja': '日本語',
    'common.coming_soon': 'Coming Soon',
  },

  ja: {
    'app.name': '便利なコピペポケット,  My Favorite Copies',
    'preview.click_paste': 'この領域をクリックしてクリップボードの内容を確認してください',
    'preview.empty': 'クリップボードにデータがありません',
    'preview.unsupported': 'サポートされていない形式です',
    'preview.permission_denied': 'クリップボードの権限が必要です。領域をクリックしてCtrl+Vを押してください',
    'preview.save': '保存',
    'preview.plain_text': 'テキストのみ',
    'preview.overwrite': '上書き',
    'preview.format_removed': '書式削除済み',
    'preview.clear': 'クリア',
    'preview.raw_source': 'ソース',
    'preview.rendered': 'レンダリング',
    'menu.save': '保存',
    'menu.cancel': 'キャンセル',
    'folder.search': 'フォルダ検索...',
    'folder.empty': 'ウィジェットをここにドラッグすると\nフォルダ構造で管理できます。',
    'folder.drop_here': 'ここにドロップ',
    'folder.new': '新しいフォルダ',
    'folder.rename': '名前変更',
    'folder.delete': 'フォルダ削除',
    'folder.delete_confirm': 'このフォルダを削除しますか？\nサブフォルダとリンクされたアイテムも解除されます。',
    'folder.items': '{count}件のアイテム',
    'widget.search': 'ウィジェット検索...',
    'widget.empty': '保存ボタンを押して\nデータを保存してください',
    'widget.text': 'テキスト',
    'widget.image': '画像',
    'widget.table': 'テーブル',
    'widget.html': 'HTML',
    'widget.markdown': 'Markdown',
    'widget.columns': '列',
    'widget.rows': '行',
    'widget.page': 'ページ',
    'widget.add_page': 'ページ追加',
    'widget.page_added': '{name}を追加しました',
    'widget.rename_page': 'ページ名を変更',
    'widget.save_page_name': 'ページ名を保存',
    'widget.cancel_page_rename': 'ページ名変更をキャンセル',
    'widget.page_renamed': '{name}に変更しました',
    'widget.delete_page': 'ページ削除',
    'widget.delete_page_confirm': '{name}を削除しますか？\nこのページのウィジェットは履歴に復旧用コピーを残してから削除されます。',
    'widget.page_deleted': '{name}を削除しました（{count}件のウィジェットを保管）',
    'widget.page_delete_last_blocked': '最後のページは削除できません',
    'widget.page_name_required': 'ページ名を入力してください',
    'widget.pages_reordered': 'ページ順を変更しました',
    'history.search': '履歴検索...',
    'history.empty': 'クリップボード履歴が\nここに表示されます',
    'storage.used': '{used} / {total} 使用中 ({percent}%)',
    'storage.remaining': '残り {size}',
    'storage.status_safe': 'ストレージには十分な空きがあります',
    'storage.status_warning': 'ストレージ容量が少なくなっています',
    'storage.status_critical': 'ストレージがほぼ満杯です。整理を検討してください。',
    'storage.guide': '利用可能なストレージ容量は、デバイスの空き状況やブラウザ環境によって動的に割り当てられます。',
    'storage.export': 'エクスポート',
    'storage.import': 'インポート',
    'storage.export_confirm': 'エクスポートを開始しますか？',
    'storage.import_confirm': 'インポートしますか？\n現在のデータはバックアップデータに置き換えられます。',
    'storage.processing': '処理中',
    'storage.complete': '完了',
    'storage.error': 'エラー',
    'storage.process_collecting': 'データ収集中...',
    'storage.process_compressing': 'データ圧縮中...',
    'storage.process_decompressing': 'データ展開中...',
    'storage.process_restoring': 'データ復旧中...',
    'storage.process_finalizing': '仕上げ中...',
    'storage.process_done': '完了しました！',
    'storage.refresh_tip': '再読み込みして変更を確認してください。',
    'info.guide': 'ガイド',
    'info.feedback': 'フィードバック',
    'info.privacy': 'プライバシーポリシー',
    'info.terms': '利用規約',
    'menu.copy': 'コピー',
    'menu.duplicate': '複製',
    'menu.edit_label': 'ラベル編集',
    'menu.edit_data': 'データ編集',
    'menu.delete': '削除',
    'menu.add_tag': 'タグ追加',
    'menu.move_to_folder': 'フォルダに移動',
    'confirm.delete': '本当に削除しますか？',
    'confirm.yes': 'OK',
    'confirm.cancel': 'キャンセル',

    // Notice
    'notice.title': 'お知らせ',
    'notice.close': 'OK',
    'notice.dont_show_today': '今日一日表示しない',

    // Context menu
    'context.copy': '複製',
    'context.move': '移動',
    'context.delete': '削除',
    'context.to_widget': 'ウィジェット領域へ',
    'context.to_page': 'ページへ',
    'context.save_png': 'PNG保存',
    'context.copy_image': 'クリップボードにコピー',
    'context.copy_base64': 'Base64コピー',
    'context.save_png_success': 'PNG保存が完了しました',
    'context.copy_image_success': 'クリップボードにコピーされました',
    'context.copy_base64_success': 'Base64コピーが完了했습니다',

    'lang.ko': '한국어',
    'lang.en': 'English',
    'lang.ja': '日本語',
    'common.coming_soon': '準備中',
  },
};

export function t(key: string, locale: Locale, params?: Record<string, string>): string {
  let text = translations[locale]?.[key] ?? translations['en']?.[key] ?? key;
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      text = text.replace(`{${k}}`, v);
    });
  }
  return text;
}

export interface I18nContextValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: string, params?: Record<string, string>) => string;
}

export const I18nContext = createContext<I18nContextValue>({
  locale: 'ko',
  setLocale: () => { },
  t: (key) => key,
});

export function useI18n(): I18nContextValue {
  return useContext(I18nContext);
}
